var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6028 0.320312H1.81951C1.52624 0.322493 1.2456 0.439964 1.03821 0.647346C0.830833 0.854728 0.713362 1.13537 0.711182 1.42865V19.212C0.713362 19.5053 0.830833 19.7859 1.03821 19.9933C1.2456 20.2007 1.52624 20.3181 1.81951 20.3203H11.3945V12.587H8.79451V9.56198H11.3945V7.33698C11.3945 4.75365 12.9695 3.34531 15.2862 3.34531C16.0612 3.34531 16.8362 3.34531 17.6112 3.46198V6.15365H16.0195C14.7612 6.15365 14.5195 6.75365 14.5195 7.62865V9.55365H17.5195L17.1278 12.5786H14.5195V20.3203H19.6028C19.8961 20.3181 20.1768 20.2007 20.3841 19.9933C20.5915 19.7859 20.709 19.5053 20.7112 19.212V1.42865C20.709 1.13537 20.5915 0.854728 20.3841 0.647346C20.1768 0.439964 19.8961 0.322493 19.6028 0.320312Z",
    fill: "#EB5B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ee101212a71a9022ba65f4199ac50d65.svg";
export { ForwardRef as ReactComponent };